import { openAlertModal } from 'admin/actions/alert-modal';
import {
  assignPaybox,
  CLEAR_SELECTED_PAYBOX_IDS,
  deletePaybox,
  getPayboxStocks,
  SET_SELECTED_PAYBOX_IDS,
} from 'admin/actions/devices';
import { getOrganizations } from 'admin/actions/organization';
import { getPrivateMoneys } from 'admin/actions/private-moneys';
import { clearShopAccounts, clearShops, getShopAccounts, getShops } from 'admin/actions/shops';
import CheckBox from 'admin/components/atoms/CheckBox';
import _Label from 'admin/components/atoms/Label';
import {
  addNullOption,
  default as Select,
  default as _Select,
} from 'admin/components/atoms/Select';
import Table from 'admin/components/atoms/Table';
import SelectedPrivateMoneyDisplay from 'admin/components/organisms/SelectedPrivateMoneyDisplay';
import Pager from 'admin/components/shared/Pager';
import ProgressBar from 'admin/components/shared/ProgressBar';
import { formatDate, toQueryParams } from 'admin/utils';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactRouterPropTypes from 'react-router-prop-types';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import Button from '../../../atoms/Buttons';
import FilterForm from './FilterForm';

const ProcessingButton = styled(Button)`
  margin-top: 0.5rem;
  &:disabled {
    background: #009239 !important;
    opacity: 0.5 !important;
    color: white;
  }
`;

const FlexWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

const DeviceTableCheckbox = styled(CheckBox)`
  width: 14px;
  height: 14px;
  border: 1px solid #666;
  border-radius: 4.5px;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: white;
  position: relative;

  &:checked {
    background-color: #2684ff;
    border-color: #2684ff;
  }

  &:checked::after {
    content: '';
    position: absolute;
    left: 4px;
    top: 1.5px;
    width: 4px;
    height: 7px;
    border: solid white;
    border-width: 0 1px 1px 0;
    transform: rotate(45deg);
  }
`;

const ListTableBox = styled.div`
  flex-grow: 1;
  min-width: 60%;
`;

const SettingBox = styled.div`
  flex-grow: 1;
  margin: 0 20px 20px 20px;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  align-self: flex-start;
  position: sticky;
  top: 5rem;
  .counting {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .button-group {
      display: flex;
      gap: 0.5rem;
    }
    span {
      font-weight: bold;
      font-size: 1.2rem;
    }
  }
  ${_Select} {
    width: 400px;
  }
  ${_Label} {
    margin: 0;
  }
`;

const LabelText = styled.span``;

const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.75rem 0;
`;

const NoResultText = styled.span`
  font-weight: 600;
  font-size: 20px;
  padding: 10px;
  text-align: center;
  display: block;
`;

const HEADERS = [
  { label: '', size: 0.5 },
  { label: 'シリアル番号', size: 3.5 },
  { label: 'ハードウェアver', size: 4 },
  { label: '製造登録日', size: 4 },
];

class Payboxes extends Component {
  constructor(props) {
    super(props);
    this.defaultPagination = { page: 1, per_page: 25 };

    const params = new URLSearchParams(props.location.search);
    const serialNumber = params.get('serialNumber') || '';

    this.state = {
      form: {
        serialNumber,
      },
      selectedOrgOption: {
        value: '',
      },
      selectedShopOption: {
        value: '',
      },
      checkingAll: false,
      lastCheckingId: null,
      shiftKeyPressed: false,
      processingAssignment: false,
      processingAssignmentCount: 0,
      currentPage: 1,
      organizations: { rows: [] },
      moneys: { rows: [] },
    };
  }

  componentDidMount() {
    this.props.clearShopAccounts();

    const userPrivateMoney = this.getUserPrivateMoney();
    if (userPrivateMoney && userPrivateMoney.id) {
      const params = toQueryParams(
        {
          page: 1,
          perPage: 10000,
          privateMoneyId: userPrivateMoney.id,
        },
        true
      );
      this.props.getOrganizations(params);
    }
  }

  componentWillMount() {
    const query = toQueryParams({ per_page: 2000 });
    getPrivateMoneys(query)
      .then((json) => {
        this.setState({
          moneys: json,
        });
      })
      .catch((e) => {
        console.error('An error occurred in listing private moneys: ', e);
      });

    this.fetchPayboxes();

    document.addEventListener('keydown', this.onKeyDown);
    document.addEventListener('keyup', this.onKeyUp);
  }

  componentWillUpdate(nextProps) {
    if (this.props.payboxStocks !== nextProps.payboxStocks) {
      const selectedIds = new Set(this.props.selectedPayboxIds);
      this.setState({
        checkingAll: nextProps.payboxStocks.rows.every((p) => selectedIds.has(p.id)),
      });
    }
    if (this.props.organizations !== nextProps.organizations) {
      const userOrganization = this.props.user.organization;
      const { organizations } = nextProps;
      if (userOrganization && !organizations.rows.find((o) => o.code === userOrganization.code)) {
        const combinedOrganizations = {
          ...organizations,
          rows: [userOrganization, ...organizations.rows],
        };
        this.setState({ organizations: combinedOrganizations });
        return;
      }
      this.setState({ organizations });
    }
    if (this.props.userPrivateMoney !== nextProps.userPrivateMoney) {
      const userPrivateMoney = nextProps.userPrivateMoney;
      if (userPrivateMoney && userPrivateMoney.id) {
        const params = toQueryParams(
          {
            page: 1,
            perPage: 10000,
            privateMoneyId: userPrivateMoney.id,
          },
          true
        );
        this.props.getOrganizations(params);

        this.setState({
          selectedOrgOption: { value: '' },
          selectedShopOption: { value: '' },
        });
        this.props.clearShopAccounts();
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
    document.removeEventListener('keyup', this.onKeyUp);
    this.props.clearShops();
    this.props.clearShopAccounts();
  }

  onKeyDown = (e) => {
    if (e.keyCode === 16) {
      this.setState({
        shiftKeyPressed: true,
      });
    }
  };

  onKeyUp = (e) => {
    if (e.keyCode === 16) {
      this.setState({
        shiftKeyPressed: false,
      });
    }
  };

  onSearch = () => {
    const params = new URLSearchParams(this.props.location.search);
    Object.keys(this.state.form).forEach((key) => {
      if (this.state.form[key]) {
        params.set(key, this.state.form[key]);
      } else {
        params.delete(key);
      }
    });

    this.props.history.replace({
      pathname: this.props.location.pathname,
      search: params.toString(),
    });

    this.fetchPayboxes();
  };

  onChangePage = (page) => {
    this.setState(
      {
        lastCheckingId: null,
        currentPage: page,
      },
      () => {
        this.fetchPayboxes({
          page: this.state.currentPage,
        });
      }
    );
  };

  onChangeForm = (e) => {
    const newForm = Object.assign({}, this.state.form, { [e.target.name]: e.target.value });
    this.setState({ form: newForm });
  };

  fetchPayboxes(pagination) {
    const pageParams = Object.assign({}, this.defaultPagination, pagination);
    const params = Object.assign({}, this.state.form, pageParams);
    this.props.getPayboxStocks(toQueryParams(params, true));
  }

  getUserPrivateMoney = () => {
    return this.props.userPrivateMoney;
  };

  onChangeOrganizationSelect = (op) => {
    if (!op.value) {
      this.resetSelectedOrgOption();
    } else if (this.state.selectedOrgOption.value !== op.value) {
      this.resetSelectedOrgOption();
      this.setState({ selectedOrgOption: op });
      const orgCode = op.value;
      const params = toQueryParams(
        {
          page: 1,
          perPage: 5000,
          organizationCode: orgCode,
        },
        true
      );
      this.props.getShops(params);
    }
  };

  onChangeShopSelect = (op) => {
    if (!op.value) {
      this.resetSelectedShopOption();
    } else if (this.state.selectedShopOption.value !== op.value) {
      this.resetSelectedShopOption();
      this.setState({ selectedShopOption: op });
      const shopId = op.value;

      const userPrivateMoney = this.getUserPrivateMoney();
      const params = toQueryParams(
        {
          privateMoneyId: userPrivateMoney?.id,
        },
        true
      );
      this.props.getShopAccounts(shopId, params);
    }
  };

  resetSelectedOrgOption = () => {
    this.setState({
      selectedOrgOption: { value: '' },
    });
    this.resetSelectedShopOption();
  };

  resetSelectedShopOption = () => {
    this.setState({
      selectedShopOption: { value: '' },
    });
  };

  onCheckPaybox = (id, state) => {
    const currentCheckedIndex = this.props.payboxStocks.rows.findIndex((r) => r.id === id);
    if (currentCheckedIndex < 0) return;

    const selectedIds = new Set(this.props.selectedPayboxIds);
    let lastCheckedIndex = -1;

    if (this.state.shiftKeyPressed) {
      if (this.state.lastCheckingId !== null) {
        lastCheckedIndex = this.props.payboxStocks.rows.findIndex(
          (r) => r.id === this.state.lastCheckingId
        );
      }
    }

    if (lastCheckedIndex >= 0) {
      const [start, end] =
        currentCheckedIndex > lastCheckedIndex
          ? [lastCheckedIndex, currentCheckedIndex]
          : [currentCheckedIndex, lastCheckedIndex];
      for (let i = start; i <= end; i += 1) {
        const iid = this.props.payboxStocks.rows[i].id;
        if (state) {
          selectedIds.add(iid);
        } else {
          selectedIds.delete(iid);
        }
      }
    } else {
      if (state) {
        selectedIds.add(id);
      } else {
        selectedIds.delete(id);
      }
    }

    this.props.setSelectedPayboxIds(Array.from(selectedIds));

    this.setState({
      checkingAll: this.props.payboxStocks.rows.every((r) => selectedIds.has(r.id)),
      lastCheckingId: id,
    });
  };

  onCheckAll = (state) => {
    const selectedIds = new Set(this.props.selectedPayboxIds);

    if (state) {
      this.props.payboxStocks.rows.forEach((r) => {
        selectedIds.add(r.id);
      });
    } else {
      this.props.payboxStocks.rows.forEach((r) => {
        selectedIds.delete(r.id);
      });
    }

    this.props.setSelectedPayboxIds(Array.from(selectedIds));

    this.setState({
      checkingAll: state,
    });
  };

  onClearAllCheck = () => {
    this.props.clearSelectedPayboxIds();

    this.setState({
      checkingAll: false,
    });
  };

  onFinished = () => {
    this.props.openAlertModal({
      body: '完了しました',
      useCancel: false,
      confirmText: 'OK',
      onConfirm: () => {
        this.setState(
          {
            processingAssignment: false,
            processingAssignmentCount: 0,
            selectedOrgOption: { value: '' },
            selectedShopOption: { value: '' },
          },
          () => {
            this.onClearAllCheck();
            this.props.clearShopAccounts();
            this.fetchPayboxes({
              page: this.state.currentPage,
            });
          }
        );
      },
    });
  };

  onDelete = () => {
    const selectedCount = this.props.selectedPayboxIds.length;
    if (selectedCount === 1) {
      const id = this.props.selectedPayboxIds[0];
      const paybox = this.props.payboxStocks.rows.find((r) => r.id === id);
      if (!paybox) return;
      this.props.openAlertModal({
        body: `ペイボックス「${paybox.serial_number}」を廃棄してよろしいですか？この操作は取り消しできません。`,
        useCancel: true,
        confirmText: '廃棄する',
        onConfirm: () => {
          this.props.deletePaybox(id).then(this.onFinished);
        },
      });
    }
  };

  onAssignAccount = () => {
    // there will always be only 1 shop account, 1:1 relationship with money
    const shopAccount = this.props.shopAccounts[0];
    const aid = shopAccount.id;
    const name = shopAccount.name;
    const selectedCount = this.props.selectedPayboxIds.length;

    this.props.openAlertModal({
      body: `${selectedCount}台のペイボックスを「${name}」に割り当てます。よろしいですか？`,
      useCancel: true,
      confirmText: '割り当てる',
      onConfirm: () => {
        this.setState({
          processingAssignment: true,
          processingAssignmentCount: 0,
        });
        const ids = [...this.props.selectedPayboxIds];
        const iter = () => {
          if (ids.length > 0) {
            const pid = ids.shift();
            this.props.assignPaybox(pid, aid).then(() => {
              const count = this.state.processingAssignmentCount + 1;
              this.setState(
                {
                  processingAssignmentCount: count,
                },
                () => {
                  setTimeout(iter, 200);
                }
              );
            });
          } else {
            this.onFinished();
          }
        };
        iter();
      },
    });
  };

  renderSettingBox() {
    const selectedCount = this.props.selectedPayboxIds.length;
    return selectedCount > 0 ? (
      <SettingBox>
        <div className="counting">
          <span>{selectedCount}台を選択中</span>
          <div className="button-group">
            <Button
              disabled={this.state.processingAssignment}
              onClick={this.onClearAllCheck}
              variant="neutral"
            >
              選択をクリア
            </Button>
            {selectedCount === 1 ? (
              <Button
                disabled={this.state.processingAssignment}
                onClick={this.onDelete}
                variant="danger"
              >
                廃棄
              </Button>
            ) : null}
          </div>
        </div>
        <hr />
        <SelectedPrivateMoneyDisplay valueTextStyles={{ fontWeight: 'bold', opacity: 1 }} />
        <SelectWrapper>
          <LabelText>組織名</LabelText>
          <Select
            options={addNullOption(
              this.state.organizations.rows.map((org) => ({
                label: org.name,
                value: org.code,
              }))
            )}
            value={this.state.selectedOrgOption.value ? this.state.selectedOrgOption : null}
            onChange={this.onChangeOrganizationSelect}
            placeholder="「組織」を選択"
          />
        </SelectWrapper>
        <SelectWrapper>
          <LabelText>店舗名</LabelText>
          <Select
            options={addNullOption(
              this.props.shops.rows.map((shop) => ({
                label: shop.name,
                value: shop.id,
              }))
            )}
            value={this.state.selectedShopOption.value ? this.state.selectedShopOption : null}
            onChange={this.onChangeShopSelect}
            placeholder="「店舗」を選択"
          />
        </SelectWrapper>

        {this.state.processingAssignment ? (
          <div>
            <ProcessingButton variant="contained" disabled>
              しばらくお待ち下さい...
            </ProcessingButton>
            <ProgressBar
              unit="台"
              prefix="割当中"
              max={selectedCount}
              showMax
              current={this.state.processingAssignmentCount}
            />
          </div>
        ) : (
          <div>
            <ProcessingButton
              onClick={this.onAssignAccount}
              disabled={this.props.shopAccounts.length === 0}
              variant="contained"
            >
              割り当てる
            </ProcessingButton>
          </div>
        )}
      </SettingBox>
    ) : (
      <SettingBox>
        <NoResultText>ペイボックスを選択してください</NoResultText>
      </SettingBox>
    );
  }

  render() {
    const selectedIds = new Set(this.props.selectedPayboxIds);
    const rows = this.props.payboxStocks.rows;

    return (
      <div>
        <FlexWrapper>
          <div style={{ flexGrow: 1, minWidth: '60%' }}>
            <FilterForm
              onSearch={this.onSearch}
              onChangeForm={this.onChangeForm}
              {...this.state.form}
            />
          </div>
          <div style={{ flexGrow: 1, minWidth: '40%' }} />
        </FlexWrapper>
        <FlexWrapper>
          <ListTableBox>
            {!rows || rows.length === 0 ? (
              <NoResultText>結果がありません</NoResultText>
            ) : (
              <Table>
                <Table.Header>
                  <Table.Row>
                    <Table.Cell size={HEADERS[0].size}>
                      <DeviceTableCheckbox
                        disabled={this.state.processingAssignment}
                        setChecked={this.onCheckAll}
                        checked={this.state.checkingAll}
                      />
                    </Table.Cell>
                    {HEADERS.slice(1).map((header, index) => (
                      <Table.Cell key={index} size={header.size}>
                        {header.label}
                      </Table.Cell>
                    ))}
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {rows.map((row) => (
                    <Table.Row key={row.id} styles={{ '& td': { padding: '0.75rem 16px' } }}>
                      <Table.Cell>
                        <DeviceTableCheckbox
                          disabled={this.state.processingAssignment}
                          setChecked={(checked) => this.onCheckPaybox(row.id, checked)}
                          checked={selectedIds.has(row.id)}
                        />
                      </Table.Cell>
                      <Table.Cell wordBreak="keep-all">{row.serial_number}</Table.Cell>
                      <Table.Cell wordBreak="keep-all">{row.hardware_ver}</Table.Cell>
                      <Table.Cell wordBreak="keep-all">{formatDate(row.created_at)}</Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
                <Table.Footer>
                  <Table.Row noBorder>
                    <Table.Cell
                      colSpan={HEADERS.length}
                      align="center"
                      styles={{ paddingTop: '16px' }}
                    >
                      <Pager
                        pagination={this.props.payboxStocks.pagination}
                        onChangePage={this.onChangePage}
                      />
                    </Table.Cell>
                  </Table.Row>
                </Table.Footer>
              </Table>
            )}
          </ListTableBox>
          {this.renderSettingBox()}
        </FlexWrapper>
      </div>
    );
  }
}

Payboxes.propTypes = {
  location: ReactRouterPropTypes.location.isRequired,
  user: PropTypes.object.isRequired,
  getPayboxStocks: PropTypes.func.isRequired,
  assignPaybox: PropTypes.func.isRequired,
  deletePaybox: PropTypes.func.isRequired,
  getOrganizations: PropTypes.func.isRequired,
  getShops: PropTypes.func.isRequired,
  getShopAccounts: PropTypes.func.isRequired,
  clearShopAccounts: PropTypes.func.isRequired,
  openAlertModal: PropTypes.func.isRequired,
  setSelectedPayboxIds: PropTypes.func.isRequired,
  clearSelectedPayboxIds: PropTypes.func.isRequired,
  payboxStocks: PropTypes.shape({
    rows: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        serial_number: PropTypes.string,
        hardware_ver: PropTypes.string,
        status: PropTypes.string,
        created_at: PropTypes.string,
      })
    ),
    count: PropTypes.number,
    pagination: PropTypes.shape({
      current: PropTypes.number,
      per_page: PropTypes.number,
      max_page: PropTypes.number,
      has_prev: PropTypes.bool,
      has_next: PropTypes.bool,
    }),
  }),
  organizations: PropTypes.object,
  shops: PropTypes.object,
  shopAccounts: PropTypes.array,
  selectedPayboxIds: PropTypes.arrayOf(PropTypes.number),
  userPrivateMoney: PropTypes.object,
};

Payboxes.defaultProps = {
  payboxStocks: { rows: [], count: 0, pagination: { current: 1, per_page: 25 } },
  organizations: { rows: [] },
  shops: { rows: [] },
  shopAccounts: [],
  selectedPayboxIds: [],
  userPrivateMoney: {},
};

const mapStateToProps = (state) => ({
  payboxStocks: state.device.payboxStocks,
  user: state.user,
  organizations: state.organization.organizations,
  shops: state.shop.shops,
  shopAccounts: state.shop.shop_accounts,
  userPrivateMoney: state.userPrivateMoney.selectedMoney,
  selectedPayboxIds: state.device.selectedPayboxIds,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPayboxStocks,
      assignPaybox,
      deletePaybox,
      getOrganizations,
      getShops,
      clearShops,
      getShopAccounts,
      clearShopAccounts,
      openAlertModal,
      setSelectedPayboxIds: (ids) => dispatch(SET_SELECTED_PAYBOX_IDS(ids)),
      clearSelectedPayboxIds: () => dispatch(CLEAR_SELECTED_PAYBOX_IDS()),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Payboxes);
